import React, { useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { SocketContext } from "contexts";
import useTicket from "hooks/use-ticket";
import CloseIconSVG from "assets/svg/CloseIconSVG";
import LeftArrowSVG from "assets/svg/LeftArrowSVG";
import { addOpenedTicket, getOpenedTickets } from "redux/slices/tickets";
import { getTicketData } from "redux/slices/ticket";
import packageJson from "../../../package.json";

const Header = () => {
  const { removeOpenTicketAndChangeRoute, navigateToTicketsView } = useTicket();
  const openedTickets = useSelector(getOpenedTickets);
  const prevOpenedTicketsLengthRef = useRef(0);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const ticket = useSelector(getTicketData);
  const { logoutAndCloseWebsocket } = useContext(SocketContext);

  useEffect(() => {
    if (params.ticketId && ticket && ticket.id === params.ticketId) {
      // Check if ticket is already in opened tickets
      const ticketExists = openedTickets?.some(
        (openTicket) => openTicket.id === params.ticketId
      );

      // Only add the ticket if it doesn't exist AND the openedTickets array didn't just shrink
      // If the array just shrunk (ticket was removed), we should NOT re-add it
      const ticketsJustRemoved =
        openedTickets.length < prevOpenedTicketsLengthRef.current;
      const shouldAdd = !ticketExists && !ticketsJustRemoved;

      if (shouldAdd) {
        dispatch(
          addOpenedTicket({
            id: params.ticketId,
            room: ticket?.relationships?.message_rooms?.data[0]?.id.toString(),
            subject: ticket?.attributes?.subject,
            hasAskedForHumanSupport:
              ticket?.attributes?.has_asked_for_human_support ?? false,
          })
        );
      }
    }

    // Always update the ref after the effect runs
    prevOpenedTicketsLengthRef.current = openedTickets.length;
  }, [dispatch, openedTickets, params.ticketId, ticket]);

  return (
    <div className="headerContainer">
      <button
        className="backButton"
        disabled={!params?.ticketId}
        onClick={navigateToTicketsView}
      >
        <LeftArrowSVG classProp={params?.ticketId ? "" : "invisibleSVG"} />
      </button>
      <div className="flexGrowOne openTicketsContainer">
        {openedTickets.map((openTicket, index) => (
          <div
            className={`openTicket rowSpaceBetween ${
              params.ticketId === openTicket.id ? "active" : ""
            }`}
            key={openTicket.id}
            style={{ alignItems: "center" }}
          >
            <div
              className="flexColumn flexGrowOne"
              onClick={() => navigate(`/ticket/${openTicket.id}`)}
              role="button"
            >
              <div className="openTicketSubject">{openTicket.subject}</div>
              <div className="openTicketId">#{openTicket.id}</div>
            </div>
            <button
              className="closeButton"
              onClick={() => removeOpenTicketAndChangeRoute(index)}
            >
              <CloseIconSVG classProp="SVGHover" />
            </button>
          </div>
        ))}
      </div>
      <div className="versionTextWrapper">
        <p>v{packageJson.version}</p>
      </div>
      <button
        className="ticketCategoryBox logoutButton"
        onClick={logoutAndCloseWebsocket}
      >
        Logout
      </button>
    </div>
  );
};

export default Header;
